<template>
    <div>
        <div class="listenPlayer">
            <audio :src="src"></audio>
            <div class="player-border">
                <div @click="backOrSpeed('back')" class="button">
                    <img src="../assets/images/back.png" alt="">
                </div>
                <div @click="playOrPause" class="button">
                    <img src="../assets/images/play.png" alt="">
                </div>
                <div @click="backOrSpeed('speed')" class="button">
                    <img src="../assets/images/speed.png" alt="">
                </div>
                <div class="time-view">
                    <span>{{playerTime}}</span>/<span>{{fullTime}}</span>
                </div>
                <div class="_progress-bar">
                    <div @click="selectTime" class="_progress-bg">
                        <div v-bind:style="{width:progress+'%'}" class="_bar"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        props: ['src'],
        created() {


        },
        ready: function () {
            this.music.src = this.src;
            let vm = this;
            this.$nextTick(function () {
                vm.audioPlayer();
            })
        },
        data() {
            return {
                audio: "",
                music: {
                    src: "",
                    fullTime: "",
                    playTime: "",
                    state: ""
                }
            }
        },
        computed: {
            'fullTime': function () {
                var m = parseInt(this.music.fullTime / 60),
                    s = parseInt(this.music.fullTime % 60);
                if (m < 10) {
                    m = '0' + m;
                }
                if (s < 10) {
                    s = '0' + s;
                }
                return m + ':' + s
            },
            'playerTime': function () {
                var m = parseInt(this.music.playTime / 60),
                    s = parseInt(this.music.playTime % 60);
                if (m < 10) {
                    m = '0' + m;
                }
                if (s < 10) {
                    s = '0' + s;
                }
                return m + ':' + s
            },
            'progress': function () {
                return this.music.playTime / this.music.fullTime * 100
            }
        },
        methods: {
            audioPlayer: function () {
                var vm = this;
                var audio = document.querySelector('audio');
                vm.audio = audio;
                setInterval(function () {
                    vm.music.fullTime = audio.duration;
                    vm.music.playTime = audio.currentTime;
                }, 100);
            },
            playOrPause: function () {
                if (this.audio.paused) {
                    this.audio.play();
                } else if (!this.audio.paused) {
                    this.audio.pause();
                }
            },
            backOrSpeed: function (type) {
                if (type === 'back') {
                    this.audio.currentTime = this.audio.currentTime - 10
                } else if (type === 'speed') {
                    this.audio.currentTime = this.audio.currentTime + 10
                }
            },
            selectTime: function (e) {
                var progress = e.offsetX / 200;
                this.audio.currentTime = this.music.fullTime * progress;
            }
            // TODO 音量调节
        }
    }

</script>
<style scoped>
    .player-border {
        border: 1px solid #ccc;
        display: inline-flex;
        width: 400px;
        height: 40px;
            border-radius: 5px;
    }
    
    .player-border .button {
        width: 20px;
        margin: 5px;
        cursor: pointer;
    }
    
    .player-border .time-view {
        line-height: 35px
    }
    
    ._progress-bar {
        margin: 0 15px;
    }
    
    ._progress-bar ._progress-bg {
        margin: 10px 0;
        height: 15px;
        width: 200px;
        border: 1px solid #ccc;
        border-radius: 8px;
        background: rgba(204, 204, 204, 0.4);
        cursor: pointer;
        overflow: hidden;
    }
    
    ._progress-bar ._bar {
        background: cornflowerblue;
        width: 0%;
        height: 14px;
        border-radius: 14px;
        transition: width 0.5s;
    }

</style>



// WEBPACK FOOTER //
// listenPlayer.vue?82301bba